import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    console.log(event.detail.resource.title);

var thumbnails = document.querySelector(".product-left");
var pageLang = document.documentElement.lang || 'en';

/* -------------------------------------------------------
   NORMALIZE TERM (your existing rules)
-------------------------------------------------------- */
function normalizeTerm(str, lang) {
    if (!str) return '';
    str = str.trim();

    // roségold → rose (complete match)
    if (/^\s*ros[eé]gold\s*$/i.test(str)) {
        return 'rose';
    }

    // roségold inside longer strings
    str = str.replace(/ros[eé]gold/ig, 'rose');

    // EN conversions
    if (lang === 'en') {
        str = str.replace(/\bsilber\b/ig, 'silver');
        str = str.replace(/\bVerstellbar\b/ig, 'Adjustable');
    }

    return str;
}

/* -------------------------------------------------------
   NEW FUNCTIONS TO SUPPORT SINGLE + MULTI TERM MATCHING  
-------------------------------------------------------- */

// Split "gold / 6mm" → ["gold","6mm"], normalized
function normalizeParts(str) {
    return normalizeTerm(str, pageLang)
        .toLowerCase()
        .split('/')
        .map(s => s.trim())
        .filter(Boolean);
}

// True if: all alt parts exist somewhere inside selected parts
function matchOptions(alt, selected) {
    const altParts = normalizeParts(alt);
    const selParts = normalizeParts(selected);

    // e.g. alt=["gold"] → must exist in selParts
    //      alt=["gold","6mm"] → both must exist
    return altParts.every(part => selParts.includes(part));
}

/* -------------------------------------------------------
   SELECTED VARIANT
-------------------------------------------------------- */
var selected = normalizeTerm(event.detail.resource.title, pageLang);
console.log(selected);


if (selected === 'Default Title') return;

// Update text
var colrElement = document.querySelector('.colr');
if (colrElement) colrElement.textContent = selected;

// Reset gallery
thumbnails.innerHTML = '';
var addImage = '';
var addImage2 = '';

/* -------------------------------------------------------
   IMAGE LOOP
-------------------------------------------------------- */
images.forEach(function(image) {

    var alt = normalizeTerm(image.alt, pageLang);
    var url = image.url;
    var url2 = image.url2;
     var width= image.width;
     var height= image.height;
console.log(alt);
    // MATCH enhanced logic
    if (matchOptions(alt, selected)) {

        addImage += `
            <div class="item">
                
                               <a href="${url}" data-pswp-width="${width}" data-pswp-height="${height}"> 
                      
                   <img class="img-fluid" loading="lazy" src="${url2}" alt="${alt}">
                </a>
            </div>`;

        addImage2 += `
            <div class="item">
                <img class="img-fluid" loading="lazy" src="${url2}" alt="${alt}">
            </div>`;
    }
});

/* -------------------------------------------------------
   SLIDER OUTPUT
-------------------------------------------------------- */
addImage = '<div class="slider-for">' + addImage + '</div> <div class="slider-nav">' + addImage2 + '</div>';
thumbnails.innerHTML = addImage;
console.log(thumbnails.innerHTML);
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: false,
    prevArrow:
        "<button type='button' class='slick-prev small-icon'><svg width='10' height='18' viewBox='0 0 10 18'><path d='M9 17L1 9L9 1' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
        "<button type='button' class='slick-next small-icon'><svg width='10' height='18' viewBox='0 0 10 18'><path d='M1 17L9 9L1 1' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    asNavFor: '.slider-nav',
      responsive: [
    {
      breakpoint: 767,
      settings: {
        fade: false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});

$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: false,
    focusOnSelect: true
});
 var lightbox = new PhotoSwipeLightbox({
        gallery: '.slider-for',
        children: 'a',
        // dynamic import is not supported in UMD version
        pswpModule: PhotoSwipe 
      });
      lightbox.init();
    const variantId = event.detail?.resource?.id;
    console.log(variantId); // just to confirm

     
    if (variantId) {
      const notVariantInput = document.querySelector('.notvariant');
      if (notVariantInput) {
        notVariantInput.value = variantId;
      }
    }
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
